<template>
  <div class="catalog-menu-item-form">
    <div class="form-group">
      <label>Название</label>
      <input
        v-model="form.title"
        type="text"
        placeholder="Введите название"
      />
    </div>
    <div class="form-group">
      <label>Тип</label>
      <select v-model="form.type">
        <option value="link">Ссылка</option>
        <option value="text">Текст</option>
      </select>
    </div>
    <template v-if="form.type === 'link'">
      <div class="form-group">
        <label>Категория (оставьте пустым, если укажете ссылку)</label>
        <select v-model="form.category_id" @change="onCategorySelect">
          <option value="">— Не выбрано —</option>
          <option
            v-for="c in categoryOptions"
            :key="c.id"
            :value="c.id"
          >
            {{ c.text }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Или произвольная ссылка</label>
        <input
          v-model="form.href"
          type="text"
          placeholder="https://..."
          @input="onHrefInput"
        />
      </div>
    </template>
    <div class="form-group">
      <label>Иконка (необязательно)</label>
      <div class="upload-block">
        <label for="catalog-menu-icon" class="upload-label">Загрузить иконку</label>
        <input
          id="catalog-menu-icon"
          class="upload-input-hidden"
          accept="image/x-png,image/jpg,image/jpeg,image/svg+xml,image/gif"
          type="file"
          @change="onFilePicked"
        />
      </div>
      <div v-if="form.icon_url || imagePreview" class="icon-preview">
        <img :src="imagePreview || form.icon_url" alt="" />
      </div>
    </div>
    <div class="form-actions">
      <va-button class="mr-2" color="secondary" @click="$emit('cancel')">
        Отмена
      </va-button>
      <va-button color="primary" @click="submit">
        Сохранить
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";

export default {
  name: "CatalogMenuItemForm",
  props: {
    node: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        title: "",
        type: "link",
        href: null,
        category_id: "",
        icon_id: null,
        icon_url: null,
      },
      file: null,
      imagePreview: null,
    };
  },
  computed: {
    categoryOptions() {
      return (this.categories || [])
        .filter((c) => c != null && c.id != null)
        .map((c) => ({
          id: c.id,
          text: c.name || c.slug || String(c.id),
        }));
    },
  },
  watch: {
    node: {
      immediate: true,
      handler(n) {
        if (n) {
          this.form = {
            title: n.title || "",
            type: n.type === "text" ? "text" : "link",
            href: n.href || null,
            category_id: n.category_id != null && n.category_id !== "" ? n.category_id : "",
            icon_id: n.icon_id || null,
            icon_url: n.icon_url || null,
          };
        }
        this.file = null;
        this.imagePreview = null;
      },
    },
  },
  methods: {
    onCategorySelect() {
      if (this.form.category_id) this.form.href = null;
    },
    onHrefInput() {
      if (this.form.href && this.form.href.trim()) this.form.category_id = "";
    },
    onFilePicked(event) {
      const f = event.target.files && event.target.files[0];
      if (f) {
        this.file = f;
        this.imagePreview = URL.createObjectURL(f);
      }
    },
    async submit() {
      const data = {
        title: this.form.title.trim(),
        type: this.form.type === "text" ? "text" : "link",
      };
      if (this.form.type === "link") {
        if (this.form.category_id != null && this.form.category_id !== "")
          data.category_id = this.form.category_id;
        else if (this.form.href && this.form.href.trim())
          data.href = this.form.href.trim();
      }
      if (this.file) {
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);
        const res = await api.post("/upload-file", formData);
        data.icon_id = res.data.id;
      } else if (this.form.icon_id) {
        data.icon_id = this.form.icon_id;
        if (this.form.icon_url) data.icon_url = this.form.icon_url;
      }
      this.$emit("submit", data);
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.25rem;
}
.form-group input[type="text"],
.form-group select {
  display: block;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
}
.form-actions {
  margin-top: 1.25rem;
}
.form-actions .mr-2 {
  margin-right: 0.5rem;
}
.upload-block {
  position: relative;
}
.upload-input-hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}
.upload-label {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
}
.icon-preview {
  margin-top: 0.5rem;
}
.icon-preview img {
  max-width: 48px;
  max-height: 48px;
  object-fit: contain;
  vertical-align: middle;
}
</style>
